function refreshAllGrids() {
	window.dispatchEvent(new CustomEvent("food:grid:refresh-all"));
}

function refreshGridsOfResource(resource: string, resourceId?: string) {
	window.dispatchEvent(
		new CustomEvent("food:grid:refresh-resource", {
			detail: { resource, resourceId },
		}),
	);
}

function updateGridRows(resource: string, rowIds: string[]) {
	window.dispatchEvent(
		new CustomEvent("food:grid:update-rows", {
			detail: { resource, rowIds },
		}),
	);
}

export { refreshGridsOfResource, refreshAllGrids, updateGridRows };
